export function isValidDateString(str: string) {
  const date = new Date(str);
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  // Additional check to handle numeric strings that might be interpreted as timestamps
  return !/^\d+$/.test(str);
}
